import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProviderOutItems } from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"
import ProviderChartOutItemsList from "components/ProviderDashboard/ProviderItems/ProviderChartOutItemsList"

const ProviderChartOutItems = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
  }
  const ProviderOutItems = useSelector(
    state => state.providerDashboard.ProviderOutItems
  )

  const buildParams = (page = 1, perPage = 10) => ({
    ...getParams,
    page,
    per_page: perPage,
  })

  // get distribution based params
  useEffect(() => {
    dispatch(getProviderOutItems(buildParams(1)))

    return () => {
      dispatch(providerDashboardAction.resetProviderOutItems())
    }
  }, [])

  const onPageClick = link => {
    let page = 1
    if (link?.url) {
      const match = link.url.match(/[?&]page=(\d+)/)
      if (match) {
        page = match[1]
      }
    }
    dispatch(getProviderOutItems(buildParams(page)))
  }

  return (
    // Provider Distributino Item list components
    <ProviderChartOutItemsList
      data={ProviderOutItems?.data?.data}
      loading={ProviderOutItems?.loading}
      totalQuantity={ProviderOutItems?.data?.total_quantity}
      pagination={{ meta: ProviderOutItems?.data?.meta, onPageClick }}
    />
  )
}

export default ProviderChartOutItems
